import {
    FAQ_SEARCH_REQUEST,
    FAQ_SEARCH_SUCCESS,
    FAQ_SEARCH_FAILURE,
} from '../../../Constants/actionTypes';

import { faq_search } from '../../../Constants/apiService'


// Action to start search
export const faqSearchRequest = () => ({
    type: FAQ_SEARCH_REQUEST,
});

// Action when search is successful
export const faqSearchSuccess = (results) => ({
    type: FAQ_SEARCH_SUCCESS,
    payload: results,
});

// Action when search fails
export const faqSearchFailure = (error) => ({
    type: FAQ_SEARCH_FAILURE,
    payload: error,
});


export const faqSearch = (query) => {
    console.log(query)
    return async (dispatch, getState) => {
        dispatch(faqSearchRequest());

        const state = getState();
        const accessToken = state.auth.accessToken;

        try {

            const data = await faq_search(accessToken, query);
            dispatch(faqSearchSuccess(data?.result));
            console.log(data?.result)

        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(faqSearchFailure(errorMessage));
        }


    };
};